module.exports = __webpack_public_path__ + "pc/img/modal_06.cf0948d6.png";